import $ from 'jquery';

import 'cadenza/conditions/selector.css';

import 'ui/data';

/**
 * filter-controller must be imported before table-slider-condition
 * (the slider needs the filter to be loaded before)
 */
import 'cadenza/conditions/filter-controller';
import 'cadenza/conditions/table-condition/table-condition';
import 'cadenza/conditions/polygon-condition/polygon-condition';
import 'cadenza/conditions/map-condition/map-condition';
import 'cadenza/conditions/table-slider-condition/table-slider-condition';
import 'cadenza/conditions/like-condition/like-condition';
import 'cadenza/conditions/oracle-text-condition/oracle-text-condition';
import 'cadenza/conditions/interval-condition/interval-condition';
import 'cadenza/conditions/two-attributes-interval-condition/two-attributes-interval-condition';
import 'cadenza/conditions/area-condition/area-condition';
import 'cadenza/conditions/tree-condition/tree-condition';
import 'cadenza/selector-result-count/selector-result-count';
import 'cadenza/hierarchy-selection/hierarchy-selection';
import 'cadenza/conditions/condition-wrapper';

import 'ui/toggletip/toggletip';

import 'cadenza/conditions/date-time-condition/date-time-condition';
import 'cadenza/conditions/date-time-condition/date-time-condition-ad-hoc-settings-panel';

/**
 * CADENZA-24008 Because of loading performance improvements in CADENZA-23644 the JS files are
 * loaded with defer attribute in the meantime and the loading order is not fixed any more.
 * We needed to connect the tableSettings with the toolbar and the tableController from outside.
 * The DOMContentLoaded event is fired after parsing JS, that's why we do the connection inside a JQuery function
 */
$(() => {
  const tableSettingsElement = document.querySelector('.d-table-settings');
  const toolbar = document.querySelector('.d-table-toolbar');
  const tableController = document.querySelector('d-table-controller');
  if (tableSettingsElement && toolbar && tableController) {
    tableSettingsElement.initTableSettings(toolbar, tableController);
  }
});
